import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Popconfirm } from 'antd'; 
import { ToastContainer, toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';

const PersonDetail = () => {
  const { person } = useParams();
  const [details, setDetails] = useState([]);
  const [allLedger, setAllLedger] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const placeholderImage = 'https://via.placeholder.com/150';
  const imgRef = useRef(null);
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentLedger, setCurrentLedger] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const deleteLedgerById = async (id) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No token found');

      const response = await fetch(`${API_BASE_URL}/ledger/deleteLedgerItem/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error('Failed to delete ledger');
      toast.success('Ledger deleted successfully');
      fetchLedger();
    } catch (error) {
      console.error('Error deleting ledger:', error);
      toast.error('Failed to delete ledger');
    }
  };

  const openEditModal = (expense) => {
    setCurrentLedger(expense);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setCurrentLedger(null);
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const uploadImage = async (image) => {
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', 'DecentBuilders');
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dwbwxh3sj/image/upload', {
        method: 'POST',
        body: data,
      });
      const urlData = await response.json();
      return urlData.url;
    } catch (error) {
      console.error(error);
      toast.error('Image upload failed.');
      return null;
    }
  };

const updateLedger = async () => {
try {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No token found');
  
  let imageUrl = currentLedger.imagePath;

  if (imageFile) {
    const uploadedImageUrl = await uploadImage(imageFile);
    if (uploadedImageUrl) {
      imageUrl = uploadedImageUrl;
    } else {
      throw new Error('Failed to upload image');
    }
  }

  const updatedLedgerData = {
    title: currentLedger.title,
    description: currentLedger.description,
    price: currentLedger.price,
    person: currentLedger.person,
    project: currentLedger.project,
    type: currentLedger.type,
    date: currentLedger.date,
    imagePath: imageUrl
  };

  const response = await fetch(`${API_BASE_URL}/ledger/updateLedger/${currentLedger._id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(updatedLedgerData),
  });

  if (!response.ok) throw new Error('Failed to update ledger');
  
  toast.success('Ledger updated successfully');
  setIsEditModalOpen(false);
  closeModal();
  fetchLedger();

} catch (error) {
  console.error('Error updating ledger:', error);
  toast.error('Failed to update ledger');
}
};

    const fetchLedger = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/ledger/getCompleteLedger`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch ledger');
        }

        const data = await response.json();
        setAllLedger(data);
      } catch (error) {
        console.error('Error fetching ledger:', error);
      }
    };
    useEffect(() => {
    fetchLedger();
  }, []);

  useEffect(() => {
    const filteredDetails = allLedger.filter(ledger => ledger.person === person);
    setDetails(filteredDetails);
  }, [person, allLedger]);

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    const img = imgRef.current;
    if (!img) return;

    let startX = e.clientX;
    let startY = e.clientY;
    const initialTransform = img.style.transform || 'translate(0px, 0px)';
    let initialTranslateX = 0;
    let initialTranslateY = 0;

    const translateMatch = initialTransform.match(/translate\(([^)]+)\)/);
    if (translateMatch) {
      [initialTranslateX, initialTranslateY] = translateMatch[1].split(',').map(value => parseFloat(value));
    }

    const onMouseMove = (e) => {
      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;
      img.style.transform = `scale(2) translate(${initialTranslateX + deltaX}px, ${initialTranslateY + deltaY}px)`;
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const totalPrice = details.reduce((acc, ledger) => acc + ledger.balance, 0).toFixed(2);

  return (
    <div className="rounded-lg h-full">
    <div className='bg-white p-3 border-b mb-2'>
    <button onClick={() => navigate(-1)}>
          <i className="fa-solid fa-arrow-left text-xl me-2"></i>
        </button>
    </div>
      <div className='flex flex-col sm:flex-row justify-between items-center text-xl font-semibold bg-themeColor2 p-3 rounded-lg text-themeColor1 m-2'>

        <h2 className="text-xl font-bold text-themeColor1">Details for {person}</h2>
        <h2 className={`text-xl font-semibold px-2 py-1 rounded-lg ${totalPrice < 0 ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
          Total: Rs. {totalPrice}
        </h2>
      </div>
      <div className='overflow-y-auto scrollbar-hidden'>
        {details.length === 0 ? (
          <p>No expenses found for this person.</p>
        ) : (
          details.map((ledger, index) => (
            <div className="flex flex-col sm:flex-row sm:gap-4 m-2 border border-gray-300 rounded-lg p-4 bg-gray-50" key={index}>
              <div className="flex-1">
                <div className='flex justify-between'>
                  <h3 className="text-lg font-semibold text-themeColor">{ledger.title}</h3>
                  <div className="px-6 pt-2 whitespace-nowrap text-sm text-themeColor flex gap-2">
                    <i className="fa-regular fa-pen-to-square cursor-pointer" onClick={() => openEditModal(ledger)}></i>
                    <Popconfirm
                      title="Are you sure you want to delete?"
                      onConfirm={() => deleteLedgerById(ledger._id)}
                      okText="Yes"
                      cancelText="No"
                      >
                      <i className="fa-solid fa-trash-can"></i>
                    </Popconfirm>
                  </div>
                </div>
                <p className="text-gray-600">Amount: Rs. {ledger.price.toFixed(2)}</p>
                <p className="text-gray-600">Date: {new Date(ledger.date).toLocaleDateString()}</p>
                <p className="text-gray-600">Type: {ledger.type}</p>
                <p className="text-gray-600">Project: {ledger.project}</p>
                <p className="text-gray-600">Description: {ledger.description}</p>
              </div>
              <div className="mt-4 sm:mt-0 sm:w-1/4 flex justify-center items-center">
                <img 
                  src={ledger.imagePath ? ledger.imagePath : placeholderImage} 
                  alt={ledger.title} 
                  className="h-auto rounded-lg cursor-pointer"
                  onClick={() => openModal(ledger.imagePath)}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" onClick={closeModal}>
          <div 
            className="relative w-full sm:w-3/4 h-full sm:h-3/4 bg-white p-4 rounded-lg overflow-hidden scrollbar-hidden" 
            onClick={e => e.stopPropagation()}
          >
            <img 
              src={selectedImage ? selectedImage : placeholderImage} 
              alt="Selected"
              className="w-full h-full object-contain cursor-pointer"
              style={{ transform: 'scale(1)', cursor: 'zoom-in' }}
              ref={imgRef}
              onMouseDown={handleMouseDown}
              onClick={(e) => {
                const img = e.target;
                if (img.style.transform === 'scale(1)') {
                  img.style.transform = 'scale(2)';
                  img.style.cursor = 'zoom-out';
                } else {
                  img.style.transform = 'scale(1)';
                  img.style.cursor = 'zoom-in';
                }
                e.stopPropagation();
              }}
            />
            <button 
              onClick={closeModal} 
              className="absolute top-0 right-0 mt-2 mr-4 text-themeColor text-2xl font-bold"
            >
              &times;
            </button>
          </div>
        </div>
      )}
       {/* Modal for Editing Ledger */}
       {isEditModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-80">
          <div className="">
            <h2 className="text-xl font-semibold mb-4">Edit Ledger</h2>
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2">Title</label>
              <input
                type="text"
                value={currentLedger.title}
                onChange={(e) => setCurrentLedger({ ...currentLedger, title: e.target.value })}
                className="border border-gray-300 rounded-md p-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2">Amount</label>
              <input
                type="text"
                value={currentLedger.price}
                onChange={(e) => setCurrentLedger({ ...currentLedger, price: e.target.value })}
                className="border border-gray-300 rounded-md p-2 w-full"
              />
            </div>
           
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2">Description</label>
              <textarea
                value={currentLedger.description}
                onChange={(e) => setCurrentLedger({ ...currentLedger, description: e.target.value })}
                className="border border-gray-300 rounded-md p-2 w-full"
              />
            </div>
            {/* Other fields like price, person, type, etc. */}
            <div className="mb-4">
              <label className="block text-sm font-bold mb-2">Image</label>
              <input type="file" onChange={handleImageChange} className="border border-gray-300 rounded-md p-2" />
              {currentLedger.imagePath && (
                <img src={currentLedger.imagePath} alt="Ledger" className="mt-2 w-32 h-32" />
              )}
            </div>
            <div className="flex justify-end">
              <button className="bg-themeColor1 text-white px-4 py-2 rounded-md" onClick={updateLedger}>
                Save
              </button>
              <button className="ml-2 bg-gray-300 text-gray-800 px-4 py-2 rounded-md" onClick={closeEditModal}>
                Cancel
              </button>
            </div>
          </div>
          </div>
        </div>
      )}
   
      <ToastContainer />
    </div>
  );
};

export default PersonDetail;
